import { useSuspenseQuery } from "@apollo/client";
import { GET_NOTIFICATION_TEMPLATE } from "../api/get-notification-template";

export function useNotificationTemplateData(id?: string) {
  return useSuspenseQuery(GET_NOTIFICATION_TEMPLATE, {
    variables: {
      id: id as string,
    },
    skip: !id,
  });
}
